import { useParams, useNavigate, Navigate } from "react-router-dom";
import { ArrowLeft, ChevronRight, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useProfile, moduleEnabled } from "@/context/BusinessProfileContext";
import { visibleItems } from "@/lib/spaces";
import { spaceColor, folderIcon } from "@/components/MesEspaces";
import { useDashPrefs } from "@/lib/dashboardPrefs";

export default function Espace() {
  const { key } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { modules } = useProfile();
  const { prefs } = useDashPrefs();
  if (!prefs) return <div className="flex justify-center h-40 items-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>;
  const space = prefs.folders.find((s) => s.id === key);
  if (!space) return <Navigate to="/dashboard" replace />;
  const Icon = folderIcon(space);
  const items = visibleItems(space, modules, user, moduleEnabled);
  return (
    <div className="max-w-4xl mx-auto" data-testid={`espace-page-${key}`}>
      <button data-testid="espace-back" onClick={() => navigate("/dashboard")} className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900 mb-4 py-2">
        <ArrowLeft className="w-5 h-5" /> Tableau de bord
      </button>
      <div className="flex items-center gap-3 mb-5">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${spaceColor(space.c)}`}><Icon className="w-6 h-6" /></div>
        <div><h1 className="font-heading text-2xl font-bold text-slate-900">{space.label}</h1><p className="text-sm text-slate-500">{space.desc}</p></div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {items.map((it, i) => (
          <button key={`${it.label}-${i}`} data-testid={`espace-item-${i}`} onClick={() => navigate(it.to)}
            className="group bg-white rounded-xl border border-slate-200 px-4 py-3.5 min-h-[56px] text-left flex items-center gap-3 hover:border-emerald-300 hover:shadow-sm transition-all">
            <div className="flex-1 min-w-0"><div className="text-sm font-semibold text-slate-900">{it.label}</div>{it.desc && <div className="text-[11px] text-slate-400">{it.desc}</div>}</div>
            <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-emerald-600 shrink-0" />
          </button>
        ))}
        {!items.length && <p className="text-sm text-slate-400">Aucune fonction disponible dans cet espace.</p>}
      </div>
    </div>
  );
}
